import { splitEntity } from "shelving";
import { JOIN_LEADERBOARD, START_CHALLENGE } from "shared/api";
import { AsyncButton, Icon, When } from "shared/react";
import { type CreatorEntity, getLeaderboardID, isChallengeEarly, isChallengeEnded, isChallengeStartable } from "shared/schema";
import { callAPI } from "../util/api.js";
import { useAttemptItem } from "../util/data.js";
import { useItem } from "../util/db.js";
import { USER } from "../util/user.js";

export function LeaderboardJoinCard({ cid, creator, mods = "" }: { cid: string; creator: CreatorEntity; mods?: string | undefined }): React.ReactElement | null {
	const [type] = splitEntity(creator);
	const challenge = useItem("challenge", cid).data;
	const joined = useItem("leaderboard", getLeaderboardID(creator, cid, "a", USER.data.uid)).value;
	const attempt = useAttemptItem(cid).value;
	if (joined) return null; // Already joined.
	return (
		<section className={`card pad-2x ${mods}`}>
			<AsyncButton
				onClick={
					isChallengeStartable(challenge)
						? async () => {
								if (!attempt) await callAPI(START_CHALLENGE, cid);
								await callAPI(JOIN_LEADERBOARD, { creator, cid });
						  }
						: undefined
				}
				mods="space-xsmall button-default"
			>
				<Icon icon="leaderboard" /> <span>Join leaderboard</span>
			</AsyncButton>
			<p className="status space-xsmall">
				{attempt ? (
					`Join this leaderboard. Your progress on this challenge will be shared with the ${type}.`
				) : isChallengeEnded(challenge) ? (
					<>
						Challenge ended <When target={challenge.end} />. This leaderboard can no longer be joined.
					</>
				) : isChallengeEarly(challenge) ? (
					<>
						Challenge starts in <When target={challenge.start} />. This leaderboard can be joined when the challenge starts.
					</>
				) : (
					`Start this challenge and join the leaderboard. Your progress on this challenge will be shared with the ${type}.`
				)}
			</p>
		</section>
	);
}
